import { request } from "@/utils/request";
//列表
export function getDeptList(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/data/queryTreeList",
    params: data,
  });
}

//上级数据（新增用）
export function getLastData(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/data/list",
    params: data,
  });
}
//新增数据
export function addData(data,config) {
  return request({
    method: "post",
    url: "/api/patrol/sys/data/add",
    data,
    config,
  });
}
//删除
export function deleteData(data) {
  return request({
    method: "delete",
    url: "/api/patrol/sys/data/delete",
    params: data,
  });
}
//编辑
export function putData(data) {
  return request({
    method: "put",
    url: "/api/patrol/sys/data/edit",
    data,
  });
}
//详情
export function getById(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/data/getById",
    params: data,
  });
}

//新增视频或图片
export function uploadFile(data,config) {
  return request({
    method: "post",
    url: "/api/patrol/sys/data/upload",
    data,
    config,
  });
}

// -------用户案例--------
export function getDeptListById(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/data/queryTreeListById",
    params: data,
  });
}



//列表
export function caseListByType(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/case/listByType",
    params: data,
  });
}


//详情
export function caseGetById(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/case/getById",
    params: data,
  });
}


//详情
export function productGetById(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/product/getById",
    params: data,
  });
}
